// import axios from 'axios'

// 本地请求地址
// export const urls = 'http://192.168.31.130:8081' // 本地
export const urls = 'https://gdlsfw.com/prod-api' // 正式
// export const urls = 'http://8.155.44.137:81/prod-api' // 正式

export {}
